import {Injectable} from '@angular/core';

import {environment} from "@src/environments/environment";
import {JavascriptInjectorService} from "@shared/services/external-scripts/javascript-injector.service";

@Injectable({
  providedIn: 'root'
})
export class HotjarService {

  constructor(private javascriptInjectorService: JavascriptInjectorService) {
  }

  tryInject() {
    if (environment.hotjarId > 0) {
      this.javascriptInjectorService.injectToHtmlHead(this.getHotjarScript());
    }
  }

  private getHotjarScript(): string {
    return `
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${environment.hotjarId},hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
  }
}
